<template>
  <el-row>
    <!-- <el-row>
      <el-checkbox v-model="options.updateAddressBook">
        Update Addressbook
      </el-checkbox>
      <el-checkbox v-model="options.updateItems">
        Update Items
      </el-checkbox>
    </el-row> -->
    <el-row>
      <el-form
        size="small"
        label-position="top"
      >
        <el-form-item
          label="Account"
          class="mb-2"
        >
          <el-autocomplete
            ref="account-search"
            v-model="accountInput"
            :fetch-suggestions="accountQuerySearch"
            :trigger-on-focus="false"
            placeholder="Enter a keyword"
            class="w-100"
            :debounce="500"
            value-key="name"
            clearable
            autofocus
            @select="handleSelectAccount"
            @clear="clearAccountInput"
          />
        </el-form-item>

        <el-form-item
          label="Team"
          required
          class="mb-2"
        >
          <el-select
            ref="team-select"
            v-model="details.team"
            placeholder="Select a team"
            class="w-100"
            value-key="id"
            filterable
            :loading="isLoadingTeams"
          >
            <el-option
              v-for="teaml in teams"
              :key="teaml.id"
              :label="teaml.name"
              :value="teaml"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="Carrier Service"
        >
          <el-select
            v-model="details.service"
            filterable
            style="width: 100%;"
            :loading="isLoadingServices"
          >
            <el-option-group
              key="algorithms"
              label="Algorithm"
            >
              <el-option
                key="quoteall"
                value="Quote All Available"
              >
                <span style="float: left">Quote All Available</span>
              </el-option>
              <el-option
                key="lowest"
                value="Lowest Cost"
              >
                <span style="float: left">Lowest Cost</span>
              </el-option>
            </el-option-group>
            <el-option-group
              v-for="group in services"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.id"
                :label="formatService(item)"
                :value="item.chainit"
              >
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.carrier.name }}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item
          label="Service Features"
        >
          <el-select
            v-model="details.features"
            filterable
            style="width: 100%;"
            multiple
            :loading="isLoadingServices"
          >
            <el-option
              key="signature"
              value="Signature Required"
            >
              <span style="float: left">Signature Required</span>
            </el-option>
            <el-option
              key="saturday"
              value="Saturday Delivery"
            >
              <span style="float: left">Saturday Delivery</span>
            </el-option>
            <el-option
              key="tailgate"
              value="Tailgate Required"
            >
              <span style="float: left">Tailgate Required</span>
            </el-option>
            <el-option
              key="insurance"
              value="Insurance"
            >
              <span style="float: left">Insurance</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="Despatch Date"
        >
          <el-date-picker
            v-model="details.date"
            type="date"
            placeholder="Despatch Date"
            style="width: 100%;"
            :default-value="new Date()"
          />
        </el-form-item>
      </el-form>
    </el-row>
  </el-row>
</template>
<script>
export default {
  props: {
    consignment: {
      type: Object,
      required: false,
      default: Object
    },
    details: {
      type: Object,
      required: false,
      default: Object
    }
  },
  data () {
    return {
      services: [],
      session: null,
      team: null,
      account: null,
      accountInput: null,
      teams: [],
      isLoadingTeams: false,
      isLoadingServices: false
    }
  },
  watch: {
    'details.team' (newTeam) {
      if (newTeam) {
        if (newTeam.shipper_setting && newTeam.shipper_setting.address) {
          this.$emit('set-default-address', newTeam.shipper_setting.address)
        }
      }
    }
  },
  activated () {
    if (!this.account) {
      this.$nextTick(() => {
        if (this.$refs['account-search']) {
          console.log('Focusing account search input from activated hook')
          // If it's a Vue component, use $el. If it's a plain HTML element, just use .focus()
          const element = this.$refs['account-search']
          element.focus()
        } else {
          console.warn('Account search input not found for focusing')
        }

        this.details.service = 'Quote All Available'
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs['account-search']) {
        console.log('Focusing account search input')
        // If it's a Vue component, use $el. If it's a plain HTML element, just use .focus()
        const element = this.$refs['account-search']
        element.focus()
      } else {
        console.warn('Account search input not found for focusing')
      }

      this.details.service = 'Quote All Available'
    })
    // console.log(this.$refs)
    // this.details.service = 'quoteall'
  },
  methods: {
    loadCarrierServices (account) {
      this.isLoadingServices = true
      this.$sdk.service.list(builder => {
        builder.page = 1
        builder.limit = 100
        builder.include = ['carrier']
        builder.filters = { account_carrier_service_setting_strict_account: [account.id] }
        builder.order = 'carrier.name:asc'
      }).then(res => {
        this.services = res.sort((a, b) => a.carrier.name.localeCompare(b.carrier.name))
        this.services = this.services.reduce(function (r, a) {
          r[a.carrier.name] = r[a.carrier.name] || []
          r[a.carrier.name].label = a.carrier.name
          r[a.carrier.name].options = r[a.carrier.name].options || []
          r[a.carrier.name].options.push(a)
          return r
        }, Object.create(null))
        this.isLoadingServices = false
      })
    },
    formatService (service) {
      if (service) {
        return `${service.carrier.name} [${service.name}]`
      } else return ''
    },
    accountQuerySearch (queryString, cb) {
      this
        .$sdk
        .account
        .list(builder => {
          builder.filters = { account_name: queryString, account_active: 1 }
          builder.include = [
            'carrier_service_settings.carrier_service.carrier',
            'carrier_service_settings.carrier_setting',
            'carrier_settings.carrier',
            'teams.shipper_setting.address'
          ]
        })
        .then(cb)
    },
    handleSelectAccount (account) {
      if (account instanceof this.$sdk.account) {
        this.accountInput = account.name
        this.teams = account.teams

        this.account = account
        this.team = null

        this.loadCarrierServices(account)

        this.$nextTick(() => {
          const selectComponent = this.$refs['team-select']
          if (selectComponent) {
            console.log('Focusing team select input after account selection')
            // 1. Focus the element
            selectComponent.focus()
            // 2. Force Element UI to open the dropdown menu
            selectComponent.visible = true
          }
        })
      }
    },
    clearAccountInput () {
      this.accountInput = ''
      // this.account = null
      this.team = null
      this.details.team = null
    }
  }
}
</script>
